import type { PriceType } from '@/types/common.ts';
import type { DateInputCultureInfo } from '@/utils/parseDateWithCultureInfo.ts';

export type HedgeTypeForUserPref = 'Live' | 'Forward' | 'Spot';

export const accountLengthOptions = ['Long', 'Short'] as const;
export type AccountLengthOption = (typeof accountLengthOptions)[number];

export const autoCloseGrowlAfterChoices = [null, 5000, 15000, 60000] as const;
export type AutoCloseGrowlAfter = (typeof autoCloseGrowlAfterChoices)[number];

export interface UserPreferencesState {
  dateInputCultureInfo: DateInputCultureInfo;
  autoCloseGrowlAfter: AutoCloseGrowlAfter;
  defaultNotional: string | null;
  defaultCashMaturityDate: string | null;
  emails: string[];
  splitNotificationsEmailsCash: string[];
  splitNotificationsEmailsOrders: string[];
  splitNotificationsEmailsOptions: string[];
  accountNameLength: AccountLengthOption;
  defaultHedgeType: HedgeTypeForUserPref;
  defaultPriceType: PriceType;

  oneClickExecution: boolean;
  resetTileOnSuccessfulExecution: boolean;
  showSwapPoints: boolean;
  showDeltaStrike: boolean;
  showMyMainDeals: boolean;
  optionOneWayQuotation: boolean;
  optionDisplayMidVolatility: boolean;
  optionStrategyGroupLegs: boolean;
  optionExpandGreekAndMkt: boolean;
  optionAlignCurrencies: boolean;
  orderQuickLimit: boolean;
  splitNotifications: boolean;
  optionIsPremiumNetted: boolean;
  resetTileToSpotOnQuoteExecution: boolean;
  showColoredPrices: boolean;
}

export const defaultUserPreferenceData: UserPreferencesState = {
  dateInputCultureInfo: 'en',
  autoCloseGrowlAfter: null,
  showSwapPoints: true,
  showDeltaStrike: false,
  splitNotifications: false,
  resetTileOnSuccessfulExecution: true,
  defaultNotional: null,
  defaultCashMaturityDate: null,
  optionOneWayQuotation: true,
  optionDisplayMidVolatility: true,
  optionStrategyGroupLegs: false,
  optionExpandGreekAndMkt: false,
  optionAlignCurrencies: false,
  showMyMainDeals: true,
  emails: [],
  accountNameLength: 'Long',
  orderQuickLimit: true,
  oneClickExecution: false,
  defaultHedgeType: 'Live',
  defaultPriceType: 'AMOUNT',
  splitNotificationsEmailsCash: [],
  splitNotificationsEmailsOrders: [],
  splitNotificationsEmailsOptions: [],

  optionIsPremiumNetted: false,
  resetTileToSpotOnQuoteExecution: false,
  showColoredPrices: false,
};
